import { render, staticRenderFns } from "./CustomLegend.vue?vue&type=template&id=5fedcc68"
import script from "./CustomLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomLegend.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports